import React from "react";
import TopNavigation from "../../components/TopNavigation/index";
import BookingTable from "../../components/Bookings/bookingTable";

export default function Dashboard() {

    return (
        <>
            <div className="h-full">
                    <main class=" h-full m-6">
                        <div className="pt-2">
                            <TopNavigation 
                                icon="fas fa-home text-sm text-gray-500"
                                name="Bookings"
                            />
                        </div>
                        {/* <div>
                            <DashboardCard />
                        </div> */}
                        <div className="mt-6 mr-2">
                            <BookingTable />
                        </div>
                    </main>
            </div>
            
        </>
    )
}